import React from 'react';
import { Layout } from '../components/layout/Layout';
import { SeoHead } from '../components/ui/SeoHead';
import { Section } from '../components/ui/Section';
import { FileText } from 'lucide-react';

export const Terms = () => {
  return (
    <Layout>
      <SeoHead
        title="Terms of Service | EnergiPro Solutions"
        description="EnergiPro Solutions terms of service: website usage, intellectual property, liability limitations, and governing law for all service engagements."
        canonicalPath="/terms"
      />
      <div className="bg-slate-900 pt-80 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <FileText className="text-orange-600" size={48} />
            <h1 className="text-4xl md:text-5xl font-bold text-white">TERMS OF SERVICE</h1>
          </div>
          <p className="text-xl text-slate-300 max-w-3xl leading-relaxed">
            Terms and conditions governing the use of the EnergiPro Solutions website.
          </p>
        </div>
      </div>

      <Section>
        <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
          <p className="text-sm text-slate-500 mb-8">Last updated: April 25, 2026</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">1. Acceptance of Terms</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            By accessing and using the EnergiPro Solutions website (&quot;Site&quot;), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you must discontinue use of the Site immediately.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">2. Use of the Website</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            This website is provided for informational and business purposes. You agree to use the Site only for lawful purposes and in accordance with these Terms. You shall not:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">
            <li>Use the Site in any way that violates applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to any part of the Site</li>
            <li>Use the Site to transmit any harmful or malicious content</li>
            <li>Reproduce, distribute, or modify any content without prior written consent</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">3. Intellectual Property</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            All content on this Site, including text, graphics, logos, images, and documentation, is the property of EnergiPro Solutions or its licensors and is protected by applicable intellectual property laws. Unauthorized use of any materials may violate copyright, trademark, and other laws.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">4. Disclaimer of Warranties</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            The information on this Site is provided &quot;as is&quot; without warranty of any kind, express or implied. While we strive to maintain accurate and up-to-date information, EnergiPro Solutions makes no representations or warranties regarding the completeness, accuracy, or reliability of any content on the Site. Operational capabilities, equipment specifications, and service descriptions are subject to change without notice.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">5. Limitation of Liability</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            EnergiPro Solutions shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of or inability to use the Site. This limitation applies regardless of the legal theory on which the claim is based.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">6. Commercial Engagements</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Inquiries submitted through this Site do not constitute binding offers or contracts. All commercial engagements are subject to formal agreement, internal approval processes, IMS controls, and client-specific qualification and authorization requirements. Terms of any business relationship will be governed by separate written agreements.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">7. External Links</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            This Site may contain links to external websites. EnergiPro Solutions is not responsible for the content, accuracy, or practices of any third-party sites. The inclusion of any link does not imply endorsement.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">8. Governing Law</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            These Terms shall be governed by and construed in accordance with the laws of the Kingdom of Saudi Arabia. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of the Kingdom of Saudi Arabia.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">9. Changes to These Terms</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting on this Site. Your continued use of the Site after any changes constitutes acceptance of the revised Terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">10. Contact</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            For questions regarding these Terms, please contact us at:<br />
            <strong>Email:</strong> <a href="mailto:info@energiprogroup.com" className="text-orange-600 hover:text-orange-700 underline">info@energiprogroup.com</a><br />
            <strong>Phone:</strong> +966 13 330 8579<br />
            <strong>Address:</strong> Level 21 Al Khobar Gate Tower (Al Shaikh Tower), King Fahad Road, PO Box 32348 Khobar 31952, KSA
          </p>
        </div>
      </Section>
    </Layout>
  );
};
